import React from 'react';
import { Button, InputLabel, NativeSelect } from '@material-ui/core';

import ChevronDownDarkIcon from 'public/icons/chevron-down-dark.svg';
import styles from 'styles/components/gigSetup/Container.module.scss';
import useOnlyFansConnections from 'hooks/useOnlyFansConnections';
import { useDispatch } from 'react-redux';
import { openModal } from 'features/utilsSlice';

const ggFreeTrialDayOptions = [
  { id: 1, value: 1, name: '1 day' },
  { id: 2, value: 3, name: '3 days' },
  { id: 3, value: 7, name: '1 week' },
  { id: 4, value: 14, name: '2 weeks' },
  { id: 5, value: 30, name: '1 month' },
  { id: 6, value: 90, name: '3 months' },
  { id: 7, value: 180, name: '6 months' },
  { id: 8, value: 360, name: '1 year' },
];

const buttonStyle = { height: '50%' };

const GGFileType = ({ values, setFieldValue }) => {
  const dispatch = useDispatch();
  const { enabledConnections } = useOnlyFansConnections();

  const selectedConnection = enabledConnections.find(
    connection => connection.id === +values.only_fans_connection_id
  );

  return (
    <>
      <InputLabel
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
      >
        Select OF account
        {enabledConnections.length > 0 && (
          <Button
            size="small"
            color="primary"
            variant="outlined"
            style={buttonStyle}
            onClick={() => dispatch(openModal({ name: 'OnlyFans Verification' }))}
          >
            + Add
          </Button>
        )}
      </InputLabel>

      {enabledConnections.length > 0 ? (
        <NativeSelect
          fullWidth
          name="only_fans_connection_id"
          className={styles.select}
          value={values.only_fans_connection_id}
          onChange={e => setFieldValue('only_fans_connection_id', e.target.value)}
          IconComponent={ChevronDownDarkIcon}
        >
          <option value="">Please select...</option>

          {enabledConnections.map(connection => (
            <option key={connection.id} value={connection.id}>
              {connection.username}
            </option>
          ))}
        </NativeSelect>
      ) : (
        <div className={styles.alertBox}>
          <span>No Enabled Accounts</span>{' '}
          <strong style={{ wordBreak: 'break-word' }}>
            <Button
              size="small"
              color="primary"
              variant="outlined"
              style={buttonStyle}
              onClick={() => dispatch(openModal({ name: 'OnlyFans Verification' }))}
            >
              Connect New
            </Button>
          </strong>
        </div>
      )}

      {selectedConnection?.account_type === 'paid' && (
        <>
          <InputLabel>Free Trial Days</InputLabel>

          <NativeSelect
            fullWidth
            name="gg_free_trial_days"
            className={styles.select}
            value={values.gg_free_trial_days}
            onChange={e => setFieldValue('gg_free_trial_days', e.target.value)}
            IconComponent={ChevronDownDarkIcon}
          >
            {ggFreeTrialDayOptions.map(option => (
              <option key={option.id} value={option.value}>
                {option.name}
              </option>
            ))}
          </NativeSelect>
        </>
      )}
    </>
  );
};

export default GGFileType;
